import { render, staticRenderFns } from "./ManualVerification.vue?vue&type=template&id=48e03028"
import script from "./ManualVerification.vue?vue&type=script&lang=js"
export * from "./ManualVerification.vue?vue&type=script&lang=js"
import style0 from "./ManualVerification.vue?vue&type=style&index=0&id=48e03028&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports